{
  "header": {
    "nameShowStaticText": true,
    "nameStaticText": "Used Model: OPC 40082-1",
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "5878f12b-29d5-4c80-bede-384c366baa9d",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/TCD/",
      "nodeId": "ns=1;i=6278",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "pr_opc40082-1.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "190f9588-9101-4c4e-9e65-2361b493e9b9",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/TCD/",
      "nodeId": "ns=1;i=6193",
      "displayName": "OperartingMode",
      "variablePath": "Operation.OperatingMode",
      "dataType": "Enum",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false,
      "enumValues": {
        "0": "OTHER",
        "1": "READY_TO_OPERATE",
        "2": "NORMAL_OPERATION",
        "3": "LEAK_STOPPER",
        "4": "MOULD_EVACUATION",
        "5": "PRESSURE_RELIEF",
        "6": "COOLING",
        "7": "SAFETY_COOLING",
        "8": "ECO",
        "9": "BOOST"
      }
    },
    "colorValues": {
      "0": "#c8c8c8",
      "1": "#ffff00",
      "2": "#00ff00",
      "3": "#00ff00",
      "4": "#ff0000",
      "5": "#ff0000",
      "6": "#ffff00",
      "7": "#ff0000",
      "8": "#00ff00",
      "9": "#00ff00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Machine Type",
              "showAsLink": false,
              "valueVariable": {
                "id": "8532932f-8329-4519-9b1f-9e674b2683d5",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/TCD/",
                "nodeId": "ns=1;i=6276",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "a9767661-ca86-4e18-aba0-8d4407e6ae0e",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/TCD/",
                "nodeId": "ns=1;i=6277",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "5878f12b-29d5-4c80-bede-384c366baa9d",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/TCD/",
                "nodeId": "ns=1;i=6278",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "739dd1a6-23eb-459c-ab04-70c1cd7927d9",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/TCD/",
                "nodeId": "ns=1;i=6279",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Specification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Max. Temperature",
              "showAsLink": false,
              "valueVariable": {
                "id": "526630ae-22b7-461a-9cfe-88f4c3581e39",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/TCD/",
                "nodeId": "ns=1;i=6540",
                "displayName": "MaxTemperature",
                "variablePath": "TCDSpecification.MaxTemperature",
                "dataType": "Int32",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Nominal Flow Rate",
              "showAsLink": false,
              "valueVariable": {
                "id": "f6ab3af3-8abb-483e-b19c-acbf330b9a01",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/TCD/",
                "nodeId": "ns=1;i=6542",
                "displayName": "NominalFlowRate",
                "variablePath": "TCDSpecification.NominalFlowRate",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Power Value",
              "showAsLink": false,
              "valueVariable": {
                "id": "b4eb0df9-e06f-4faf-ba9d-c962ae10e6b4",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/TCD/",
                "nodeId": "ns=1;i=6544",
                "displayName": "PowerValue",
                "variablePath": "TCDSpecification.PowerValue",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Temperature",
              "valueVariable": {
                "id": "0bbdfb04-c635-4298-a3fb-95cb9a1f5c23",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/TCD/",
                "nodeId": "ns=1;i=6365",
                "displayName": "ActualValue",
                "variablePath": "DeviceZone.Temperature.ActualValue",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ],
          "title": "Device Zone"
        }
      ]
    }
  ]
}
